import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorCodesService, SharedUiInputsModule } from '@shared/ui/inputs';
import { SharedFeatureTranslateModule } from '@shared/feature/translate';
import { FormsErrorCodesService } from './services/forms-error-codes.service';

@NgModule({
  imports: [CommonModule, SharedUiInputsModule, SharedFeatureTranslateModule],
  providers: [{ provide: ErrorCodesService, useClass: FormsErrorCodesService }],
  exports: [SharedUiInputsModule],
})
export class SharedFeatureFormsModule {}
